import UserService from '@/services/requests/userService'
import Store from '@/store/computed/storeHelpers'
export default {
  methods: {
    getUsers() {
      this.loadingUsers = true;
      UserService.getAllUsers().then(result => {
        //console.log(result);
        this.loadingUsers = false;
        this.users = result.data.result;
      }).catch(err => {
        console.log(err);
        this.loadingUsers = false;
        this.snackError();
      })
    }
  },
  computed: {
    loadingUsers: Store.getSet({ store: 'users', prop: 'loadingUsers' }),
    users: Store.getSet({ store: 'users', prop: 'users' })
  },
  mounted() {
    if (!this.users.length) {
      this.getUsers()
    }
  },
  beforeDestroy() {
    if (!this.keepMasterFiles) this.users = [];
  },
}